module.exports = __webpack_public_path__ + "static/img/uploadbg.0838896.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/uploadbg.png
// module id = +lJw
// module chunks = 0